module.exports = __webpack_public_path__ + "img/underwater-city.3b1dea5a.jpg";